(() => {
  function initialize(root) {
    if (root.dataset.ready) return;
    const variantsNode = root.querySelector('[data-pp-variants]');
    if (!variantsNode) return;
    const variants = JSON.parse(variantsNode.textContent);
    const select = root.querySelector('[data-pp-select]');
    const groups = [...root.querySelectorAll('[data-option-index]')];
    const form = root.querySelector('.pp-form');
    const button = root.querySelector('[data-pp-add]');
    const quantity = root.querySelector('[data-pp-quantity]');
    const quantityButtons = [...root.querySelectorAll('[data-pp-quantity-change]')];
    const saleBadge = root.querySelector('[data-pp-sale]');
    const status = root.querySelector('[data-pp-status]');
    const statusText = root.querySelector('[data-pp-status-text]');
    const delivery = root.querySelector('[data-pp-delivery]');
    const selectedVariantText = root.querySelector('[data-pp-selected-variant]');
    const stickyBar = root.querySelector('[data-pp-mobile-bar]');
    const stickyButton = root.querySelector('[data-pp-sticky-add]');
    const stickyPrice = root.querySelector('[data-pp-sticky-price]');
    const stickyVariant = root.querySelector('[data-pp-sticky-variant]');
    const checkoutLink = root.querySelector('[data-pp-checkout]');
    const reviewCarousel = root.querySelector('[data-review-carousel]');

    function syncQuantityButtons() {
      const value = Number(quantity.value);
      const min = Number(quantity.min) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      quantityButtons.forEach(control => {
        control.disabled = Number(control.dataset.ppQuantityChange) < 0 ? value <= min : value >= max;
      });
      syncCheckoutLink();
    }

    quantityButtons.forEach(control => {
      control.hidden = false;
      control.addEventListener('click', () => {
        if (!quantity.checkValidity() || quantity.value === '') quantity.value = quantity.min || '1';
        quantity.stepUp(Number(control.dataset.ppQuantityChange));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    quantity.addEventListener('input', syncQuantityButtons);
    quantity.addEventListener('change', syncQuantityButtons);

    let selected = variants.find(variant => String(variant.id) === String(select.value)) || variants[0];
    let syncingSelect = false;

    function syncCheckoutLink() {
      if (!checkoutLink) return;
      const available = Boolean(selected && selected.available);
      checkoutLink.setAttribute('aria-disabled', String(!available));
      if (!available) {
        checkoutLink.removeAttribute('href');
        return;
      }
      const qty = Math.max(Number(quantity.min) || 1, Number(quantity.value) || 1);
      const numericVariantId = String(selected.id).split('/').pop();
      const rootUrl = root.dataset.cartRoot || '/';
      const base = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';
      checkoutLink.href = base + 'cart/' + encodeURIComponent(numericVariantId) + ':' + encodeURIComponent(qty);
    }

    function showMedia(id) {
      if (!id || !root.querySelector(`[data-media-id="${id}"]`)) return;
      root.querySelectorAll('[data-media-id]').forEach(media => {
        media.hidden = media.dataset.mediaId !== String(id);
        if (media.hidden) media.querySelectorAll('video').forEach(video => video.pause());
      });
      root.querySelectorAll('[data-show-media]').forEach(thumb => {
        thumb.setAttribute('aria-pressed', String(thumb.dataset.showMedia === String(id)));
      });
    }

    root.querySelectorAll('[data-show-media]').forEach(thumb => {
      thumb.addEventListener('click', () => showMedia(thumb.dataset.showMedia));
    });
    const firstMedia = root.querySelector('[data-active]') || root.querySelector('[data-media-id]');
    if (firstMedia) showMedia(firstMedia.dataset.mediaId);
    const thumbnails = root.querySelector('.pp-thumbnails');
    if (thumbnails) thumbnails.hidden = false;

    function update(variant, updateURL = true) {
      selected = variant;
      const available = Boolean(variant && variant.available);
      const nextSelectValue = variant ? String(variant.id) : '';
      if (String(select.value) !== nextSelectValue) {
        select.value = nextSelectValue;
        syncingSelect = true;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        syncingSelect = false;
      }
      select.disabled = !variant;
      button.disabled = !available;
      button.textContent = !variant ? root.dataset.unavailableLabel : available ? root.dataset.addLabel : root.dataset.soldLabel;

      root.querySelector('[data-pp-price]').textContent = variant ? variant.price : root.dataset.unavailableLabel;
      const compare = root.querySelector('[data-pp-compare]');
      compare.hidden = !variant || !variant.compare;
      compare.textContent = variant && variant.compare ? variant.compare : '';

      if (saleBadge) {
        const hasSaving = variant && variant.compareCents && Number(variant.compareCents) > Number(variant.priceCents);
        saleBadge.hidden = !hasSaving;
        if (hasSaving) {
          const percentage = Math.round((Number(variant.compareCents) - Number(variant.priceCents)) / Number(variant.compareCents) * 100);
          saleBadge.textContent = `${root.dataset.saveLabel} ${percentage}%`;
        }
      }

      if (status && statusText) {
        status.classList.toggle('is-sold', !available);
        statusText.textContent = !variant ? root.dataset.unavailableLabel : available ? root.dataset.availableLabel : root.dataset.soldLabel;
      }
      if (delivery && variant) delivery.textContent = variant.digital ? root.dataset.digitalDeliveryLabel : root.dataset.physicalDeliveryLabel;
      if (selectedVariantText && variant) selectedVariantText.textContent = variant.title;

      if (stickyPrice) stickyPrice.textContent = variant ? variant.price : root.dataset.unavailableLabel;
      if (stickyVariant && variant) {
        stickyVariant.textContent = variant.title;
        stickyVariant.hidden = variant.title === 'Default Title';
      }
      if (stickyButton) {
        stickyButton.disabled = !available;
        stickyButton.textContent = !variant ? root.dataset.unavailableLabel : available ? root.dataset.addLabel : root.dataset.soldLabel;
      }
      syncCheckoutLink();

      if (variant) {
        quantity.min = variant.min;
        quantity.step = variant.step;
        if (variant.max) quantity.max = variant.max;
        else quantity.removeAttribute('max');
        const entered = Number(quantity.value) || variant.min;
        quantity.value = Math.min(variant.max || Infinity, Math.max(variant.min, variant.min + Math.floor((entered - variant.min) / variant.step) * variant.step));
        syncQuantityButtons();
        if (variant.mediaId) showMedia(variant.mediaId);
        if (updateURL) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }

      const choices = groups.map(group => group.querySelector('input:checked')?.value);
      groups.forEach((group, position) => {
        group.querySelectorAll('input').forEach(input => {
          const matching = variants.filter(candidate => candidate.options[position] === input.value && choices.slice(0, position).every((choice, index) => candidate.options[index] === choice));
          input.closest('label').classList.toggle('pp-unavailable', !matching.some(candidate => candidate.available));
        });
      });
    }

    groups.forEach((group, position) => {
      group.addEventListener('change', () => {
        const choices = groups.map(optionGroup => optionGroup.querySelector('input:checked')?.value);
        let variant = variants.find(candidate => candidate.options.every((value, index) => value === choices[index]));
        if (!variant) {
          const candidates = variants.filter(candidate => choices.slice(0, position + 1).every((value, index) => candidate.options[index] === value));
          variant = candidates.find(candidate => candidate.available) || candidates[0];
          if (variant) {
            groups.forEach((optionGroup, index) => {
              optionGroup.querySelectorAll('input').forEach(input => {
                input.checked = input.value === variant.options[index];
              });
            });
          }
        }
        update(variant);
      });
    });

    select.addEventListener('change', () => {
      if (syncingSelect) return;
      const variant = variants.find(candidate => String(candidate.id) === String(select.value));
      if (variant) {
        groups.forEach((group, index) => {
          group.querySelectorAll('input').forEach(input => {
            input.checked = input.value === variant.options[index];
          });
        });
      }
      update(variant);
    });

    form.addEventListener('submit', event => {
      if (!selected || !selected.available) event.preventDefault();
    });

    if (stickyButton) stickyButton.addEventListener('click', () => form.requestSubmit(button));

    if (stickyBar && 'IntersectionObserver' in window) {
      let primaryButtonVisible = true;
      const syncSticky = () => {
        const sectionVisible = root.getBoundingClientRect().bottom > 120;
        const shouldShow = window.matchMedia('(max-width: 899px)').matches && window.scrollY > 240 && !primaryButtonVisible && sectionVisible;
        stickyBar.classList.toggle('is-visible', shouldShow);
        stickyBar.setAttribute('aria-hidden', String(!shouldShow));
      };
      const observer = new IntersectionObserver(entries => {
        primaryButtonVisible = entries[0].isIntersecting;
        syncSticky();
      }, { threshold: 0.15 });
      observer.observe(button);
      window.addEventListener('scroll', syncSticky, { passive: true });
      window.addEventListener('resize', syncSticky);
      syncSticky();
    }

    if (reviewCarousel) {
      const reviewTrack = reviewCarousel.querySelector('[data-review-track]');
      const reviewProgress = reviewCarousel.querySelector('[data-review-progress]');

      if (reviewTrack) {
        const syncReviewProgress = () => {
          if (!reviewProgress) return;
          const maxScroll = Math.max(1, reviewTrack.scrollWidth - reviewTrack.clientWidth);
          const ratio = Math.min(1, Math.max(0, reviewTrack.scrollLeft / maxScroll));
          const visibleRatio = Math.min(1, reviewTrack.clientWidth / Math.max(reviewTrack.clientWidth, reviewTrack.scrollWidth));
          const width = Math.max(18, visibleRatio * 100);
          const travel = 100 - width;
          reviewProgress.style.width = width + '%';
          reviewProgress.style.transform = 'translateX(' + (travel * ratio) + '%)';
        };

        const reviewNav = reviewCarousel.querySelector('[data-review-nav]');
        const prevButton = reviewCarousel.querySelector('[data-review-prev]');
        const nextButton = reviewCarousel.querySelector('[data-review-next]');
        const scrollbar = reviewCarousel.querySelector('[data-review-scrollbar]');
        const DRAG_THRESHOLD = 6;

        const maxScrollLeft = () => Math.max(0, reviewTrack.scrollWidth - reviewTrack.clientWidth);

        const stepSize = () => {
          const card = reviewTrack.querySelector('.pp-review-card');
          if (!card) return reviewTrack.clientWidth;
          const gap = parseFloat(getComputedStyle(reviewTrack).columnGap || getComputedStyle(reviewTrack).gap) || 0;
          return card.getBoundingClientRect().width + gap;
        };

        const scrollBy = delta => {
          reviewTrack.scrollTo({ left: Math.min(maxScrollLeft(), Math.max(0, reviewTrack.scrollLeft + delta)), behavior: 'smooth' });
        };

        const syncNav = () => {
          const max = maxScrollLeft();
          if (reviewNav) reviewNav.hidden = max <= 1;
          if (prevButton) prevButton.disabled = reviewTrack.scrollLeft <= 1;
          if (nextButton) nextButton.disabled = reviewTrack.scrollLeft >= max - 1;
        };

        const syncAll = () => {
          syncReviewProgress();
          syncNav();
        };

        if (prevButton) prevButton.addEventListener('click', () => scrollBy(-stepSize()));
        if (nextButton) nextButton.addEventListener('click', () => scrollBy(stepSize()));

        reviewTrack.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            scrollBy(stepSize());
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            scrollBy(-stepSize());
          } else if (event.key === 'Home') {
            event.preventDefault();
            reviewTrack.scrollTo({ left: 0, behavior: 'smooth' });
          } else if (event.key === 'End') {
            event.preventDefault();
            reviewTrack.scrollTo({ left: maxScrollLeft(), behavior: 'smooth' });
          }
        });

        if (scrollbar) {
          scrollbar.addEventListener('click', event => {
            const rect = scrollbar.getBoundingClientRect();
            if (rect.width <= 0) return;
            const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
            const visibleRatio = Math.min(1, reviewTrack.clientWidth / Math.max(reviewTrack.clientWidth, reviewTrack.scrollWidth));
            const thumb = Math.max(0.18, visibleRatio);
            const target = Math.min(1, Math.max(0, (ratio - thumb / 2) / Math.max(0.0001, 1 - thumb)));
            reviewTrack.scrollTo({ left: target * maxScrollLeft(), behavior: 'smooth' });
          });
        }

        // Mouse drag to scroll (touch uses native scrolling).
        let dragging = false;
        let moved = false;
        let startX = 0;
        let startScroll = 0;

        reviewTrack.addEventListener('dragstart', event => event.preventDefault());

        reviewTrack.addEventListener('pointerdown', event => {
          if (event.pointerType === 'touch' || event.button !== 0) return;
          dragging = true;
          moved = false;
          startX = event.clientX;
          startScroll = reviewTrack.scrollLeft;
        });

        reviewTrack.addEventListener('pointermove', event => {
          if (!dragging) return;
          const delta = event.clientX - startX;
          if (!moved) {
            if (Math.abs(delta) < DRAG_THRESHOLD) return;
            moved = true;
            reviewTrack.classList.add('is-dragging');
            try { reviewTrack.setPointerCapture(event.pointerId); } catch (error) { /* ignore */ }
          }
          event.preventDefault();
          reviewTrack.scrollLeft = startScroll - delta;
        });

        const stopDragging = event => {
          if (!dragging) return;
          dragging = false;
          if (moved) {
            moved = false;
            reviewTrack.classList.remove('is-dragging');
            if (reviewTrack.hasPointerCapture && reviewTrack.hasPointerCapture(event.pointerId)) reviewTrack.releasePointerCapture(event.pointerId);
          }
        };

        reviewTrack.addEventListener('pointerup', stopDragging);
        reviewTrack.addEventListener('pointercancel', stopDragging);
        reviewTrack.addEventListener('lostpointercapture', stopDragging);
        reviewTrack.addEventListener('scroll', syncAll, { passive: true });
        window.addEventListener('resize', syncAll);
        window.addEventListener('load', syncAll);
        requestAnimationFrame(syncAll);
      }
    }

    const native = root.querySelector('[data-native-variants]');
    const options = root.querySelector('[data-option-groups]');
    const selectedSummary = root.querySelector('.pp-selected');
    const mobilePicker = window.matchMedia('(max-width: 899px)');

    function syncVariantPickerMode() {
      const isMobile = mobilePicker.matches;
      if (native) native.hidden = !isMobile;
      if (options) options.hidden = isMobile;
      if (selectedSummary) selectedSummary.hidden = isMobile;
    }

    if (mobilePicker.addEventListener) mobilePicker.addEventListener('change', syncVariantPickerMode);
    else if (mobilePicker.addListener) mobilePicker.addListener(syncVariantPickerMode);

    root.dataset.ready = 'true';
    syncVariantPickerMode();
    update(selected, false);
  }

  function scan(container = document) {
    container.querySelectorAll('[data-paleon-product]').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
